export const owner = {
  corporationName: {
    title: 'Owners corporation name',
    type: 'simple-text',
    value: ''
  },
  contactPerson: {
    title: 'Owners corporation contact person',
    type: 'simple-text',
    value: ''
  },
  corporationPhoneWork: {
    title: 'Owners corporation phone work',
    type: 'phone',
    value: ''
  },
  corporationPhoneMobile: {
    title: 'Owners corporation phone mob',
    type: 'mobile',
    value: ''
  },
  corporationEmailPrimary: {
    title: 'Owners corporation email primary',
    type: 'email',
    value: ''
  },
  corporationEmailAlternative: {
    title: 'Owners corporation email alternative',
    type: 'email',
    value: ''
  }
}
